var map = {
	"./alert.png": "9c01",
	"./arrow-right.png": "c768",
	"./arrow.svg": "21e2",
	"./asia-flag.svg": "32c2",
	"./canada-flag.ai": "57e3",
	"./canada-flag.svg": "49ea",
	"./cart.svg": "daca",
	"./chair.svg": "6a1c",
	"./close_icon.png": "cec6",
	"./csv.png": "7828",
	"./customer-service.svg": "c5af",
	"./dining-chair.svg": "a194",
	"./dining-table.svg": "acb1",
	"./dining.svg": "0c47",
	"./document.svg": "4aa0",
	"./email-1.svg": "8cc3",
	"./email.svg": "43be",
	"./error-black.svg": "a231",
	"./facebook.svg": "8485",
	"./flower.svg": "84d2",
	"./heart-active.svg": "2de0",
	"./heart.svg": "7d16",
	"./instagram.svg": "bd6c",
	"./linkedin.svg": "9ed9",
	"./logo-2.svg": "3286",
	"./logo-white.svg": "49f8",
	"./logo.svg": "5b1c",
	"./password.png": "5d06",
	"./pdf.svg": "5730",
	"./pinterest.svg": "17dd",
	"./placeholder.svg": "0139",
	"./plus.svg": "eb38",
	"./profile-icon.svg": "4a36",
	"./quote.svg": "1636",
	"./rating-star-active.svg": "9d54",
	"./rating-star.svg": "a4c1",
	"./return.svg": "60e9",
	"./search.svg": "d103",
	"./shield.svg": "64fe",
	"./signin.png": "2840",
	"./sofa.svg": "0509",
	"./sofat.svg": "ab17",
	"./star-yellow.svg": "2e59",
	"./star.svg": "cc90",
	"./success-icon.svg": "13a1",
	"./telephone.svg": "b11a",
	"./trash-bin.svg": "903b",
	"./twitter.svg": "acf9",
	"./unsuccessful.svg": "52c0",
	"./upload.svg": "5a96",
	"./usa-flag.svg": "9edc",
	"./user.png": "3e52",
	"./user_icon.png": "662f",
	"./user_large.png": "3975",
	"./white-right-arrow.svg": "1e80",
	"./youtube-logotype.svg": "f6b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";